import React from "react";
import { CustomButtom } from "../../../../components/BotaoCTA/styles";

import { Wrapper, Container, TextWrap, Title, Image } from "./style";

import { useSelector } from "react-redux";

const selector = state => ({
  component: state.component
});

export default function NascemosParaFacilitar() {
  const scrollToOffer = () => {
    const el = document.querySelector("#plans");
    const yOffset = -80;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const { component } = useSelector(selector);
  const {
    tagTitle,
    tagTitleColor,
    tagImg,
    tagTextButton,
    tagColorButton,
    tagColorTextButton,
    tagBgColor
  } = component;
  return (
    <Wrapper style={{ backgroundColor: tagBgColor }}>
      <Container>
        <Image src={`https://` + tagImg} />
        <TextWrap>
          <Title color={tagTitleColor}>{tagTitle}</Title>
          <CustomButtom
            color="primary"
            label={tagTextButton}
            onClick={scrollToOffer}
            style={{
              backgroundColor: tagColorButton,
              color: tagColorTextButton
            }}
          />
        </TextWrap>
      </Container>
    </Wrapper>
  );
}
